module.exports = __webpack_public_path__ + "static/media/mn.5f43e0c6.svg";